import { useMutation } from '@tanstack/react-query'
import { putUpdateCryptoPayoutById } from 'services/MasspayoutService'

export const usePutUpdateMassCryptoPayoutMutation = () => {
  return useMutation({ mutationFn: putUpdateCryptoPayoutById })
}
